import { TYPE_COLLECTION } from './input-types';

export const id = 'shipmentNotification';
export const apiKey = 'ShipmentEmailSent';
export const type = TYPE_COLLECTION;

export const shipmentNotification = {
  id,
  apiKey,
  type,
};
